<template>
  <page-outline :title="$t('administration.user_add')">
    <template slot="pageContent">
      <b-row class="pb-3 no-gutters">
          <back-button></back-button>
      </b-row>
      <form-accordion :title="$t('administration.user')" :isTitleUpperCase="false">
        <div class="form-group">
        </div>
        <b-row>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="login" isMandatory
              :inputLabel="$t('administration.login')" :placeholderValue="$t('administration.login')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="name" isMandatory
              :inputLabel="$t('administration.name')" :placeholderValue="$t('administration.name')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="6" class="form-group">
            <label>
              {{ $t('administration.active') }}
            </label>
            <select :alt="$t('common.environnment_type')" class="form-control" id="sel4" v-model="active" readonly>
              <option value="0"> {{ $t('administration.no') }} </option>
              <option value="2"> {{ $t('administration.yes') }} </option>
            </select>
          </b-col>
          <b-col sm="6" class="form-group">
            <label>{{$t('common.pwd')}}</label>
            <div class="d-flex">
              <input v-model="password"
                class="form-control inputAccordionForm h-30px"
                :type="passwordType">
                <div class="icon icon-password mt-2 pt-1 icon-field"
                  :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                  @click="switchPasswordType">
                </div>
            </div>
          </b-col>
        </b-row>
      </form-accordion>
      <br>
      <form-accordion :title="$t('administration.profile')"  :isTitleUpperCase="false">
        <b-row class="justify-content-start">
          <b-col cols="3">
            <a id="profile-picker-link" class="combo-list-field d-flex justify-content-between"
              href="#">
              <span :class="'fixed-span-size ' + (profileDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplay.label }}</span>
              <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
            </a>
            <b-popover target="profile-picker-link"
              :title="$t('administration.select_profile')"
              triggers="focus" placement="bottom">
              <span v-for="(profile, index) in profiles" :key="'filtered-profile-' + profile.id_rights_profile + '-' + index">
                <b-form-checkbox v-model="profile.state"
                  :value="1"
                  :unchecked-value="0">
                  <span>{{ profile.libelle }}</span>
                </b-form-checkbox>
              </span>
            </b-popover>
          </b-col>
          <!-- <b-col cols="3" v-if="isNormSRTP">
            <b-form-checkbox :class="" v-model="srtpNorm">{{ $t('common.norm_SRTP') }}</b-form-checkbox>
            <b-col cols="12" class="px-0" v-if="srtpNorm">
              <a id="profile-picker-link-srtp" class="combo-list-field d-flex justify-content-between"
                href="#">
                <span :class="'fixed-span-size ' + (profileDisplaySRTP.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplaySRTP.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
              </a>
              <b-popover target="profile-picker-link-srtp"
                :title="$t('administration.select_profile')"
                triggers="focus" placement="bottom">
                <span v-for="(profile, index) in SRTPProfiles" :key="'filtered-profile-' + profile.id_rights_profile + '-' + index">
                  <b-form-checkbox v-model="profile.state"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('rights.db_profiles.' + profile.libelle).slice(0, -4) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </b-col>
          </b-col>
          <b-col cols="3" v-if="isNormHRTP">
            <b-form-checkbox v-model="hrtpNorm">{{ $t('common.norm_HRTP') }}</b-form-checkbox>
            <b-col cols="12" class="px-0" v-if="hrtpNorm">
              <a id="profile-picker-link-hrtp" class="combo-list-field d-flex justify-content-between"
                href="#">
                <span :class="'fixed-span-size ' + (profileDisplayHRTP.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplayHRTP.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
              </a>
              <b-popover target="profile-picker-link-hrtp"
                :title="$t('administration.select_profile')"
                triggers="focus" placement="bottom">
                <span v-for="(profile, index) in HRTPProfiles" :key="'filtered-profile-' + profile.id_rights_profile + '-' + index">
                  <b-form-checkbox v-model="profile.state"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('rights.db_profiles.' + profile.libelle).slice(0, -5) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </b-col>
          </b-col>
          <b-col cols="3" v-if="isNormPSD2">
            <b-form-checkbox v-model="psd2Norm">{{ $t('common.norm_PSD2') }}</b-form-checkbox>
            <b-col cols="12" class="px-0" v-if="psd2Norm">
              <a id="profile-picker-link-psd2" class="combo-list-field d-flex justify-content-between"
                href="#">
                <span :class="'fixed-span-size ' + (profileDisplayPSD2.nb > 0 ? 'filter-item-input-complete' : '')">{{ profileDisplayPSD2.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
              </a>
              <b-popover target="profile-picker-link-psd2"
                :title="$t('administration.select_profile')"
                triggers="focus" placement="bottom">
                <span v-for="(profile, index) in PSD2Profiles" :key="'filtered-profile-' + profile.id_rights_profile + '-' + index">
                  <b-form-checkbox v-model="profile.state"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('rights.db_profiles.' + profile.libelle).slice(0, -5) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </b-col>
          </b-col> -->
        </b-row>
        <b-row class="justify-content-start">

        </b-row>
      </form-accordion>
      <b-row class="accordionForm mt-3 justify-content-end form-group p-0 pr-2 no-gutters">
        <b-button variant="primary"
          @click="createUser()">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"

import {loadPage} from '@/helpers/routing'
import _ from 'lodash'

export default {
  name: 'EditUserCompany',
  components: {
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'back-button': backButton
  },
  props: ['idCompany'],
  data () {
    return {
      active: '2',
      countries: [],
      filteredNorms: [],
      hrtpNorm: false,
      idCountry: '',
      login: '',
      name: '',
      password: '',
      passwordType: 'password',
      profiles: [],
      psd2Norm: false,
      srtpNorm: false,
      id_rights_profile: ''
    }
  },
  computed: {
    filteredProfiles () {
      return this.profiles.filter(elem => {
        return !elem.libelle.includes('_SRTP') && !elem.libelle.includes('_HRTP')
      })
    },
    hasCountrySelector () {
      return !this.$engine.rights.getCurrentCountry().idCountry
    },
    isNormSRTP () {
      return this.$engine.user.getUserNorm() === '1' || this.$engine.rights.rightIs('super_admin', true)
    },
    isNormHRTP () {
      return this.$engine.user.getUserNorm() === '2' || this.$engine.rights.rightIs('super_admin', true)
    },
    isNormPSD2 () {
      return this.$engine.user.getUserNorm() === '3' || this.$engine.rights.rightIs('super_admin', true)
    },
    SRTPProfiles () {
      return this.profiles.filter(elem => {
        return elem.libelle.includes('_SRTP')
      })
    },
    HRTPProfiles () {
      return this.profiles.filter(elem => {
        return elem.libelle.includes('_HRTP')
      })
    },
    PSD2Profiles () {
      return this.profiles.filter(elem => {
        return elem.libelle.includes('_PSD2')
      })
    },
    hasNorms () {
      return !!this.profiles.filter(elem => {
        return elem.libelle.includes('Norm_')
      }).length
    },
    isPasswordFieldHidden () {
      return this.passwordType === 'password'
    },
    normDisplay () {
      let realNormList = this.filteredNorms.filter(norm => norm.state === 1)
      if (realNormList.length === 0) {
        return {
          label: this.$t('requestToPay.select_standard'),
          nb: 0
        }
      }
      return {
        label: realNormList.map(elem => elem.libelle).join(', '),
        nb: realNormList.length
      }
    },
    profileDisplayHRTP () {
      let realProfileList = this.realProfileList.filter(status => status.label.includes('_HRTP') && status.state === 1)
      let that = this
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => that.$t('rights.db_profiles.' + elem.label).slice(0, -5)).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    profileDisplayPSD2 () {
      let realProfileList = this.realProfileList.filter(status => status.label.includes('_PSD2') && status.state === 1)
      let that = this
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => that.$t('rights.db_profiles.' + elem.label).slice(0, -5)).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    profileDisplaySRTP () {
      let realProfileList = this.realProfileList.filter(status => status.label.includes('_SRTP') && status.state === 1)
      let that = this
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => that.$t('rights.db_profiles.' + elem.label).slice(0, -4)).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    profileDisplay () {
      let realProfileList = this.realProfileList.filter(status => status.state === 1)
      if (realProfileList.length === 0) {
        return {
          label: this.$t('administration.select_profile'),
          nb: 0
        }
      } else if (realProfileList.length < 3) {
        return {
          label: realProfileList.map(elem => elem.label).join(', '),
          nb: 1
        }
      } else {
        return {
          label: this.$t('administration.selected_profile_many', {nb: realProfileList.length}),
          nb: realProfileList.length
        }
      }
    },
    realProfileList () {
      let that = this
      const list = []
      for (const property in that.profiles) {
        const profile = that.profiles[property]
        list.push({
          tag: property,
          label: profile.libelle,
          state: profile.state,
          id: profile.id_rights_profile
        })
      }
      return list
    }
  },
  created () {
    this.countries = Object.entries(this.$engine.rights.getCountries()).map(([key, value]) => ({ idCountry: Number(key), ...value }))
    this.idCountry = this.countries[0].idCountry
    this.profiles = this.$engine.company.profiles.sort((a, b) => {
      return a.libelle.toUpperCase() > b.libelle.toUpperCase() ? 1 : -1
    })
    this.filteredNorms = _.cloneDeep(this.profiles.filter(profile => {
      return profile.libelle.includes('Norm_')
    }))
    let that = this
    this.filteredNorms.forEach(profile => {
      profile.active = 0
      profile.libelle = that.$i18n.t('requestToPay.norms.' + profile.libelle.split('_')[1])
    })
    this.filteredNorms.sort(function (a, b) {
      return a.libelle < b.libelle ? -1 : 1
    })
  },
  methods: {
    createUser () {
      let that = this

      if (this.formHasError()) {
        return
      }

      this.$engine.usercompany.addUser(
        (this.idCompany && this.idCompany !== 'undefined' ? this.idCompany : this.$engine.user.get().id),
        {
          Login: this.login,
          Name: this.name,
          Active: this.active,
          Password: this.password ? this.password : undefined
        },
        this.realProfileList.filter(status => status.state === 1).map(elem => parseInt(elem.id))
      ).then(resp => {
        console.log('resp', resp)
        if (resp.data.updated === '1') {
          that.$f7.alert(that.$i18n.t('administration.existing_user_updated_desc'), that.$i18n.t('administration.existing_user_updated'))
        } else {
          that.$f7.modal({
            title: that.$i18n.t('administration.user_added'),
            buttons: [
              {
                text: 'OK',
                onClick: function () {
                  return
                }
              }
            ]
          })
        }
        //that.$bus.$emit('switch-selected-menu', '/usercompany/')
        if (that.idCompany && that.idCompany !== 'undefined') {
          loadPage(that, {url: '/detail/' + that.idCompany})
        } else {
          loadPage(that, {url: '/usercompany/'})
        }
      })
      .catch(e => {
        if (!e.response.data.errorDescription) {
          e.response.data.errorDescription = e.response.data.description
        }
        errorMessageAlert(e, that)
      })
    },
    formHasError () {
      let regexPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{15,40}$/
      if (this.login === undefined || this.login === '') {
        this.okMessageBox(this.$t('usercompany.missing_login'))
        return true
      }
      if (this.name === undefined || this.name === '') {
        this.okMessageBox(this.$t('usercompany.missing_name'))
        return true
      }
      if (this.password === undefined || this.password === '') {
        this.okMessageBox(this.$t('usercompany.missing_password'))
        return true
      }
      if (this.password && !regexPassword.test(this.password)) {
        this.okMessageBox(this.$t('profilesPage.password_wrong_format'))
        return true
      }
      // if (!this.realProfileList.filter(status => status.state === 1
      //     && ((that.hrtpNorm && status.label.includes('_HRTP'))
      //       || (that.srtpNorm && status.label.includes('_SRTP'))
      //       || (that.psd2Norm && status.label.includes('_PSD2'))
      //       || (!status.label.includes('_HRTP') && !status.label.includes('_SRTP') && !status.label.includes('_PSD2')))).length) {
      //   this.okMessageBox(this.$t('usercompany.missing_profile'))
      //   return true
      // }
      return false
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    switchPasswordType () {
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    }
  }
}
</script>
